import { ResourceLabelContentArg } from '@fullcalendar/resource';
import React from 'react';
import styles from './UnitLabel.module.scss';

type UnitLabelProps = ResourceLabelContentArg;

export const UnitLabel: React.FC<UnitLabelProps> = ({ resource }) => {
    const isUnavailable = resource?.extendedProps?.isUnavailable;

    return (
        <div className={styles.root}>
            <p className={styles.unitName}>
                {resource?.title}
                {isUnavailable ? ' - Unavailable' : ''}
            </p>
            <p className={styles.roomName}>{resource?.extendedProps?.room?.name}</p>
        </div>
    );
};
